var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrow2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 245,
    height: 100,
    viewBox: "0 0 245 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M66.9904 24.0065L0.625495 35.6424L30.5102 99.886L40.3994 80.7285C123.076 98.8518 186.287 77.6957 244.051 0.525627C149.392 75.0776 56.0059 45.951 56.7438 43.8564C57.4817 41.7619 66.9904 24.0065 66.9904 24.0065Z",
    fill: "url(#paint0_linear_3480_18882)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3480_18882",
    x1: -5.66857,
    y1: 47.8353,
    x2: 229.933,
    y2: 22.1579,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.102421,
    stopColor: "#CFE1CA",
    stopOpacity: 0.13
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6EBCF6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow2);
export default __webpack_public_path__ + "static/media/arrow2.a8c11b5be85b980b7f2b1e20956fde4b.svg";
export { ForwardRef as ReactComponent };